import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import auth from "../../services/authService";

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const user = auth.getCurrentUser();

    if (!user) {
        auth.logout()
            .then(res => {
                // This part will likely not work as expected because `logout` is async
                // and we can't suspend rendering to wait for it.
                // The user will be redirected immediately.
            })
            .catch(err => {
                // Handle logout error, maybe redirect to an error page or just home
            });
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
